import { ApiPaths } from "@shared/constants/ApiPaths";
import { PagePaths } from "@shared/constants/PagePaths";

export class RedirectHandler {
  private static NEEDS_REDIRECT_STATUS = [302, 401, 0];
  private constructor() {}

  /**
   * リダイレクトを処理する
   * @param res
   * @returns boolean redirectされたかどうか
   * @description 302や401のリダイレクトを検知して、
   *              LocationヘッダーのURLにリダイレクトする。
   *              Locationヘッダーが取得できない場合はtrueを返す。
   */
  public static handleRedirect(
    res: Response | { status: number; headers: Headers },
  ): void {
    if (RedirectHandler.NEEDS_REDIRECT_STATUS.includes(res.status)) {
      const redirectUrl = res.headers.get("Location");
      if (!redirectUrl || !/^http(s)?:\/\//.test(redirectUrl)) {
        throw RedirectHandler.redirectToLogin();
      }

      const fullUrl = redirectUrl.match(/^http(s)/)
        ? redirectUrl
        : PagePaths.abs(redirectUrl);

      // ここでリダイレクトが発生するため、never型(error)を返す
      window.location.replace(fullUrl);
      throw new Error(`Redirecting to ${fullUrl}`);
    }
  }

  /**
   * ログインページへリダイレクトします。
   * 未認証の場合に使用される関数です。
   */
  public static redirectToLogin = (): never => {
    console.warn("User is not authenticated. Redirecting to login page.");

    window.location.href = ApiPaths.Gateway.redirectManager;

    // この関数は決して戻らないため、never型を返します。
    throw new Error("Redirecting to login");
  };
}
